import { render, staticRenderFns } from "./bulletinTransferCards.vue?vue&type=template&id=04419ce8&"
import script from "./bulletinTransferCards.vue?vue&type=script&lang=js&"
export * from "./bulletinTransferCards.vue?vue&type=script&lang=js&"
import style0 from "./bulletinTransferCards.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports